// extracted by mini-css-extract-plugin
export var cardContainer = "HotspotCard-module--cardContainer--2zoHM";
export var cardHeader = "HotspotCard-module--cardHeader--2zXIN";
export var cardThumb = "HotspotCard-module--cardThumb--GMiE-";
export var cardImageContainer = "HotspotCard-module--cardImageContainer--AHudj";
export var cardBody = "HotspotCard-module--cardBody--3iY4n";
export var showBody = "HotspotCard-module--showBody--J5pKO";
export var cardFooter = "HotspotCard-module--cardFooter--3d4Fc";